import {
  carouselProgressContainerStyles,
  carouselProgressTrackStyles,
  carouselProgressBarStyles,
} from "./styles/carousel-navigation.styles";

export const CarouselProgressBar = () => {
  return (
    <div className={carouselProgressContainerStyles()}>
      <div className={carouselProgressTrackStyles()}>
        <div className={carouselProgressBarStyles()} />
      </div>
    </div>
  );
};
